'use strict';
import React, { Component, useRef } from 'react';
import ReactDOM from 'react-dom';

import ApplicationForm from "../pages/form/index.js";

const domContainer = document.querySelector('#application-form');
ReactDOM.render(<ApplicationForm />, domContainer);
